module.exports = __webpack_public_path__ + "static/media/M2B.0ae9e968.png";